'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _keys = require('babel-runtime/core-js/object/keys');

var _keys2 = _interopRequireDefault(_keys);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactRouter = require('react-router');

var _reactIntl = require('react-intl');

var _pacomo = require('utils/pacomo');

var _components2 = require('components');

var _reduxUi = require('redux-ui');

var _reduxUi2 = _interopRequireDefault(_reduxUi);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var PassengerItem = function PassengerItem(_ref) {
    var firstName = _ref.firstName,
        lastName = _ref.lastName,
        passengerId = _ref.passengerId,
        isSelected = _ref.isSelected,
        handleClick = _ref.handleClick;
    return _react2.default.createElement(
        _reactRouter.Link,
        { to: '/' + passengerId },
        _react2.default.createElement(
            'li',
            {
                className: isSelected ? 'selected' : '',
                onClick: handleClick },
            _react2.default.createElement(_components2.IconPassenger, null),
            ' ',
            firstName,
            ' ',
            lastName
        )
    );
};

var PassengersDropdown = function PassengersDropdown(_ref2) {
    var passengersById = _ref2.passengersById,
        passengerId = _ref2.passengerId,
        ui = _ref2.ui,
        updateUI = _ref2.updateUI;

    var passengers = (0, _keys2.default)(passengersById).map(function (paxId, i) {
        var passenger = passengersById[paxId];
        return _react2.default.createElement(PassengerItem, {
            key: i,
            firstName: passenger.name.legal_first_name,
            lastName: passenger.name.legal_last_name,
            passengerId: passenger.id,
            isSelected: passenger.id == passengerId,
            handleClick: function handleClick() {
                updateUI('passengersDropdownIsVisisble', false);
            }
        });
    });
    return _react2.default.createElement(
        'ul',
        { className: ui.passengersDropdownIsVisisble ? 'visible' : 'hidden' },
        passengers,
        _react2.default.createElement(
            _reactRouter.Link,
            { to: '/', className: 'seperator' },
            _react2.default.createElement(
                'li',
                {
                    onClick: function onClick() {
                        return updateUI('passengersDropdownIsVisisble', false);
                    } },
                _react2.default.createElement(_components2.IconPassengers, null),
                ' ',
                _react2.default.createElement(_reactIntl.FormattedMessage, {
                    id: 'passengersDropdownIsVisisble.view_all',
                    defaultMessage: 'All Passengers' })
            )
        )
    );
};
PassengersDropdown = (0, _reduxUi2.default)()((0, _pacomo.pacomoTransformer)(PassengersDropdown));

var NavWithNamelist = function NavWithNamelist(props) {
    return _react2.default.createElement(
        'nav',
        null,
        _react2.default.createElement(
            'ul',
            null,
            _react2.default.createElement(
                'li',
                { className: 'dark-left-btn nav-item border-right' },
                _react2.default.createElement(
                    'span',
                    { className: 'clicker', onClick: function onClick() {
                            props.updateUI('passengersDropdownIsVisisble', !props.ui.passengersDropdownIsVisisble);
                        }, 'aria-hidden': 'false' },
                    _react2.default.createElement(
                        'span',
                        { className: 'desktop-text', 'aria-hidden': 'false' },
                        _react2.default.createElement(_reactIntl.FormattedMessage, {
                            id: 'navMenu.passengers',
                            defaultMessage: 'Select Traveller' }),
                        _react2.default.createElement(_components2.IconDown, null)
                    )
                ),
                _react2.default.createElement(PassengersDropdown, {
                    passengersById: props.passengersById,
                    passengerId: props.passengerId
                })
            ),
            props.showRequirements && _react2.default.createElement(
                'li',
                { className: 'pull-xs-right menu-btn nav-item border-left' },
                _react2.default.createElement(_components2.HamburgerMenu, null)
            ),
            props.showRequirements && _react2.default.createElement(
                'li',
                { className: 'pull-xs-right dark-menu-btn nav-item border-left' },
                _react2.default.createElement(
                    _reactRouter.Link,
                    { to: '/' + props.passengerId },
                    _react2.default.createElement(
                        'span',
                        { className: 'desktop-text', 'aria-hidden': 'true' },
                        _react2.default.createElement(_reactIntl.FormattedMessage, {
                            id: 'navMenu.requirements',
                            defaultMessage: 'Requirements' })
                    )
                )
            )
        )
    );
};

exports.default = (0, _reduxUi2.default)()((0, _pacomo.pacomoTransformer)(NavWithNamelist));
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./app/components/Passenger/NavWithNamelist.js
// module id = 1304
// module chunks = 0